"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var modal_1 = require("../../components/common/modal");
var MergeMembers = require("../../core/gql/mutations/merge-members");
var SetFeedbackMessage = require("../../core/gql/mutations/set-feedback-message");
var react_apollo_1 = require("react-apollo");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
require("../common/modal-full.scss");
var dateTimeFormatter = new Intl.DateTimeFormat('en-US', {
    month: "short",
    day: "numeric",
    year: "numeric"
});
var MergeMembersModal = function (_a) {
    var onClose = _a.onClose, onMergeSuccess = _a.onMergeSuccess, isOpen = _a.isOpen, members = _a.members, orgId = _a.orgId;
    var _b = React.useState(null), keepMember = _b[0], setKeepMember = _b[1];
    var _c = react_apollo_1.useMutation(MergeMembers.MUTATION), mergeMembers = _c[0], mergeMembersResponse = _c[1];
    var setFeedbackMessage = react_apollo_1.useMutation(SetFeedbackMessage.MUTATION)[0];
    var isLoading = mergeMembersResponse.loading;
    var clearAndClose = function () {
        setKeepMember(null);
        onMergeSuccess();
    };
    var handleClick = function (_e) { return __awaiter(void 0, void 0, void 0, function () {
        var duplicateMemberIds, mergeMembersResponse_1, e_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    duplicateMemberIds = members.filter(function (m) {
                        return m != keepMember;
                    }).map(function (m) {
                        return parseInt(m.id);
                    });
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, mergeMembers({
                            variables: {
                                organizationId: parseInt(orgId + ""),
                                primaryMemberId: parseInt(keepMember.id),
                                duplicateMemberIds: duplicateMemberIds
                            }
                        })];
                case 2:
                    mergeMembersResponse_1 = _c.sent();
                    if ((_b = (_a = mergeMembersResponse_1 === null || mergeMembersResponse_1 === void 0 ? void 0 : mergeMembersResponse_1.data) === null || _a === void 0 ? void 0 : _a.mergeMembers) === null || _b === void 0 ? void 0 : _b.id) {
                        setFeedbackMessage({ variables: {
                                message: keepMember.firstName + " " + keepMember.lastName + " has been made the primary member.",
                                autoclose: true,
                                isError: false,
                            } });
                        clearAndClose();
                    }
                    else {
                        setFeedbackMessage({ variables: {
                                message: "Unable to merge members into " + keepMember.firstName + " " + keepMember.lastName + " ",
                                autoclose: false,
                                isError: true,
                            } });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _c.sent();
                    setFeedbackMessage({ variables: {
                            message: "Unable to merge members into " + keepMember.firstName + " " + keepMember.lastName + " ",
                            autoclose: false,
                            isError: true,
                        } });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var rows = members.map(function (member) { return ({
        name: React.createElement(React.Fragment, null,
            React.createElement("div", null, member.name),
            React.createElement("div", { className: "u-fontSizeSm" },
                "Created ",
                dateTimeFormatter.format(Date.parse(member.insertedAt)))),
        gender: member.gender,
        birthdate: member.birthdate,
        id: member.id,
        keep: (React.createElement(teamsnap_ui_1.Radio, { name: member.id, label: "Keep", group: "keep", isInline: true, className: "Checkbox Checkbox--radio Checkbox--pill", inputProps: {
                checked: member.id == (keepMember === null || keepMember === void 0 ? void 0 : keepMember.id),
                onChange: function () {
                    setKeepMember(member);
                }
            } })),
    }); });
    return (React.createElement(modal_1.default, { isOpen: isOpen, onClose: clearAndClose },
        React.createElement(teamsnap_ui_1.Panel, null,
            React.createElement(teamsnap_ui_1.PanelHeader, { className: "Panel-header", title: "Merge Members" }),
            React.createElement(teamsnap_ui_1.PanelBody, { className: "Panel-body" },
                React.createElement(teamsnap_ui_1.PanelRow, null,
                    React.createElement("h4", { className: "u-spaceBottomSm" }, "Which member profile would you like to keep?"),
                    React.createElement("p", null, "Merging member profiles will use the data from the non-primary member profiles to fill in gaps with the primary profile. The non-primary profiles will then be removed from the list."),
                    React.createElement(teamsnap_ui_1.Table, { mods: "u-spaceTopMd", style: { maxHeight: "300px", overflow: "scroll" }, className: "Panel", isLoading: isLoading, columns: [
                            {
                                label: "Member Name",
                                name: 'name',
                                mods: "u-size2of8"
                            },
                            {
                                label: 'Gender',
                                name: 'gender',
                                mods: "u-size1of8 u-flex u-flexCol u-flexJustifyCenter"
                            },
                            {
                                label: 'Birthdate',
                                name: 'birthdate',
                                mods: "u-size1of8 u-flex u-flexCol u-flexJustifyCenter"
                            },
                            {
                                label: null,
                                name: "keep",
                                align: "right",
                                mods: "u-size1of8"
                            }
                        ], placeHolder: "Nothing to see here", rows: rows }))),
            React.createElement(teamsnap_ui_1.PanelFooter, { className: "Panel-footer" },
                React.createElement(teamsnap_ui_1.Button, { color: "negative", icon: "dismiss", onClick: onClose }, "Cancel"),
                React.createElement(teamsnap_ui_1.Button, { mods: "u-spaceLeftSm", color: "primary", isDisabled: !keepMember, onClick: handleClick }, "Merge")))));
};
exports.default = MergeMembersModal;
//# sourceMappingURL=merge-members-modal.js.map